import { anyObj } from '../types';

const getStaticMap = (lngLatType: any, location: string, otherParams?: anyObj) => { // otherParams: zoom | size | markers
  return import(
  	/* webpackChunkName: "map_common" */
    './getStaticMapAsync'
  ).then((defaultModule) => defaultModule.default?.(lngLatType, location, otherParams));
}

export default getStaticMap;